<template>
  <div class="mt-5 md:mt-8">
    <CommonSectionLabel
      class="no-print order-1 lg:order-none"
      title="JobAndNames"
      size="large"
      add-header-tag
    />
    <CommonPromo
      class="no-print order-last lg:order-none"
      :icon="false"
      header1="BestNames"
      header2="BestNames2"
      :small="true"
      placement="full"
    />
    <div class="container no-print">
      <LayoutColumns>
        <template #left>
          <AdsConceptAd
            v-if="isSite('altinget_se')"
            class="lg:hidden"
            id="altinget-mob2"
          />
          <ListNames
            v-if="isSite('altinget_dk')"
            class="order-last lg:order-none"
            label="JobChange"
            :type="3"
            placement="side"
          />
          <ListNames v-else class="order-last lg:order-none" placement="side" />
          <ListJobs
            v-if="isSite('altinget_se')"
            class="order-last lg:order-none"
            :count="5"
            :random="true"
          />
        </template>
        <template #main>
          <CommonPaywall class="order-2 lg:order-none" placement="main" />
          <ListJobs class="order-3 lg:order-none" :count="4" :random="true" />
          <ListArticles
            class="order-last lg:order-none"
            :count="2"
            type="articletype"
            :article-type="nameArticleTypeId"
            :lazy="false"
            :preload-first-image="true"
            placement="main"
          />
        </template>
        <template #right>
          <CommonEditorCard
            v-if="isSite('altinget_se', 'altinget_no')"
            class="order-last lg:order-none"
            :id="adEditorId"
            :show-label="false"
          />
        </template>
      </LayoutColumns>
    </div>
    <CommonPromo
      v-if="isSite('altinget_se')"
      class="no-print container"
      header1="FindTheBest"
      header2="FindTheBest2"
      cta-label="FindTheBestCTA"
      cta="https://www.altinget.se/annoncer"
      disclaimer=""
      icon-type="announcement"
    />
    <AdsConceptAd
      class="no-print hidden lg:block"
      id="altinget-lb2"
      :full-width="true"
    />
    <AdsConceptAd
      v-if="isSite('altinget_dk')"
      class="no-print lg:hidden order-last"
      id="altinget-mob4"
      :full-width="true"
    />
    <AdsConceptAd
      v-if="isSite('altinget_se')"
      class="no-print lg:hidden order-last"
      id="altinget-mob3"
      :full-width="true"
    />
    <div class="container no-print">
      <CommonSectionLabel
        class="no-print order-last lg:order-none"
        title="NamesNews"
      />
      <LayoutColumns>
        <template #left>
          <AdsConceptAd class="hidden lg:block" id="altinget-rec1" />
          <AdsConceptAd
            v-if="isSite('altinget_no')"
            class="lg:hidden order-8"
            id="altinget-mob2"
          />
          <ListArticles
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :paper="1"
            label="FrontpageNow"
            type="instream"
            placement="side"
          />
        </template>
        <template #main>
          <ListNames
            class="order-last lg:order-none"
            :count="8"
            :offset="isSite('altinget_dk') ? 0 : 5"
            :show-more="true"
            placement="main"
          />
        </template>
        <template #right>
          <AdsConceptAd class="hidden lg:block" id="altinget-rec2" />
          <AdsConceptAd
            v-if="isSite('altinget_no')"
            class="lg:hidden order-8"
            id="altinget-mob3"
          />
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            class="lg:hidden order-7"
            id="altinget-mob2"
          />
          <ListJobs
            class="order-last lg:order-none"
            :count="5"
            :random="true"
          />
        </template>
      </LayoutColumns>
    </div>
    <CommonSectionLabel
      class="no-print order-last lg:order-none"
      title="Birthdays"
      link="Routes.Birthdays"
      link-label="ShowAll"
      :link-to-paper="true"
    />
    <ListBirthdays
      class="no-print order-last lg:order-none"
      type="slider"
      :count="16"
      placement="full"
    />
    <div v-if="isSite('altinget_dk')" class="container no-print">
      <CommonSectionLabel
        class="no-print order-last lg:order-none"
        title="Alle job"
      />
      <LayoutColumns>
        <template #left>
          <AdsConceptAd class="hidden lg:block" id="altinget-rec3" />
          <AdsConceptAd class="lg:hidden order-7" id="altinget-mob3" />
        </template>
        <template #main>
          <ListJobs class="order-last lg:order-none" :count="8" />
        </template>
        <template #right>
          <ListMostRead class="order-last lg:order-none" />
          <AdsConceptAd class="hidden lg:block" id="altinget-rec4" />
          <AdsConceptAd class="lg:hidden order-7" id="altinget-mob4" />
        </template>
      </LayoutColumns>
    </div>
    <AdsConceptAd
      v-else-if="isSite('altinget_se', 'altinget_no')"
      class="no-print hidden lg:block"
      id="altinget-lb3"
      :full-width="true"
    />
    <CommonSectionLabel
      class="no-print order-24 lg:order-none"
      title="Papers"
      link="Routes.Papers"
      link-label="ShowAllPapers"
    />
    <ListPapers class="no-print order-last lg:order-none" />
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()

const indexStore = useIndexStore()

const nameArticleTypeId = isSite('altinget_se') ? 93 : 135

const adEditorId = computed(() => {
  switch (config.public.site.identifier) {
    case 'altinget_se':
      return 'carl-eyton'
    case 'altinget_no':
      return 'marius-zachariasen'
  }
})

if (!indexStore.currentPaper) {
  throw createError({ statusCode: 404 })
}

useSeoMeta({
  title: indexStore.currentPaperSlug
    ? config.public.site.meta.title.postfix.short +
      indexStore.currentPaper?.Name
    : config.public.site.meta.title.postfix.long,
})
</script>
